import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  IoChevronBackCircle,
  IoBusiness,
  IoPerson,
  IoCall,
  IoMail,
  IoChevronDown,
  IoClose,
  IoCheckmark,
  IoRibbon,
  IoCard,
  IoCloudUpload,
  IoExpand,
  IoLocation,
  IoHome,
  IoCompass,
  IoMap
} from "react-icons/io5";
import noidaMapImage from "../assets/noida_map_mockup.jpg";

const steps = [
  {
    number: 1,
    title: "Centre Details",
  },
  {
    number: 2,
    title: "License & Documents details",
  },
  {
    number: 3,
    title: "Address Details",
  },
];

const vendorItems = [
  "Company Name",
  "Contact Person",
  "Phone number",
  "Email Address",
];

const licenseItems = [
  "DRUG License No. part 1",
  "DRUG License No. part 2",
  "PAN Number",
  "FSSAI Number",
  "GST Number",
];

const addressItems = [
  "Building Number, Block, Area",
  "Landmark",
  "Area Pin Code",
  "City",
  "District",
  "State",
];

const vendorLabelMap = {
  "Company Name": "companyName",
  "Contact Person": "contactPerson",
  "Phone number": "phoneNumber",
  "Email Address": "email",
};

const licenseLabelMap = {
  "DRUG License No. part 1": "drugLicensePart1",
  "DRUG License No. part 2": "drugLicensePart2",
  "PAN Number": "panNumber",
  "FSSAI Number": "fssaiNumber",
  "GST Number": "gstNumber",
};

const addressLabelMap = {
  "Building Number, Block, Area": "building",
  "Landmark": "landmark",
  "Area Pin Code": "pinCode",
  "City": "city",
  "District": "district",
  "State": "state",
};

const Centers = () => {
  const navigate = useNavigate();
  const [isAdding, setIsAdding] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    companyName: "",
    contactPerson: "",
    phoneNumber: "",
    email: "",
    drugLicensePart1: "",
    drugLicensePart2: "",
    panNumber: "",
    fssaiNumber: "",
    gstNumber: "",
    building: "",
    landmark: "",
    pinCode: "",
    city: "",
    district: "",
    state: "",
    latitude: "",
    longitude: "",
  });

  const [centersList, setCentersList] = useState([
    {
      companyName: "Aarogya India Noida",
      contactPerson: "Veer Sinha",
      phoneNumber: "7838082254",
      email: "aaronawada12@gmail.com",
      drugLicensePart1: "UP-123456XXXX",
      drugLicensePart2: "UP-123456XXXX",
      panNumber: "XXXXXXX73A",
      fssaiNumber: "XXXXXXXXXX175",
      gstNumber: "22AAAAA0000A1Z5",
      building: "23, Block E, Sector 63",
      landmark: "Police Chawki",
      pinCode: "201014",
      city: "Noida",
      district: "Gautam Buddha Nagar",
      state: "Uttar Pradesh",
      latitude: "28.613241",
      longitude: "77.381349",
    },
    {
      companyName: "Aarogya India Delhi",
      contactPerson: "Rahul Sharma",
      phoneNumber: "9876543210",
      email: "delhi.center@aarogyaindia.com",
      drugLicensePart1: "DL-987654XXXX",
      drugLicensePart2: "DL-987654XXXX",
      panNumber: "YYYYYYY84B",
      fssaiNumber: "YYYYYYYYYY286",
      gstNumber: "07BBBBB1111B2Y6",
      building: "Building 45, Connaught Place",
      landmark: "Near Rajiv Chowk Metro",
      pinCode: "110001",
      city: "New Delhi",
      district: "New Delhi",
      state: "Delhi",
      latitude: "28.6304",
      longitude: "77.2177",
    }
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    if (!formData.companyName.trim()) {
      alert("Please enter a Centre Name");
      return;
    }
    // Add current form data to centers list
    setCentersList((prev) => [...prev, { ...formData }]);
    // Reset form data to empty
    setFormData({
      companyName: "",
      contactPerson: "",
      phoneNumber: "",
      email: "",
      drugLicensePart1: "",
      drugLicensePart2: "",
      panNumber: "",
      fssaiNumber: "",
      gstNumber: "",
      building: "",
      landmark: "",
      pinCode: "",
      city: "",
      district: "",
      state: "",
      latitude: "",
      longitude: "",
    });
    // Go back to list view
    setIsAdding(false);
    setCurrentStep(1);
    alert("New Centre added successfully!");
  };

  return (
    <>
      {!isAdding ? (
        <>
          {/* Header */}
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <p
                onClick={() => navigate("/b2b-partners")}
                className="mt-[7px] cursor-pointer text-4xl text-[#5D804E] hover:text-[#4E6B41] transition-colors duration-200"
              >
                <IoChevronBackCircle />
              </p>
              <h1 className="text-[30px] font-[600] text-[#1A1A1A]">
                Centers List
              </h1>
            </div>

            <button
              onClick={() => setIsAdding(true)}
              className="rounded-full bg-[#5D804E] hover:bg-[#4E6B41] hover:shadow-[0_4px_15px_rgba(93,128,78,0.3)] px-6 py-2.5 text-white font-semibold transition-all duration-300 flex items-center gap-1.5 hover:-translate-y-0.5"
            >
              <span>+ Add new centre</span>
            </button>
          </div>

          {/* Cards Grid */}
          <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {centersList.map((center, idx) => (
              <div
                key={idx}
                className="bg-white rounded-3xl p-6 border border-gray-200 hover:border-[#5D804E] hover:shadow-[0_12px_40px_rgba(93,128,78,0.1)] hover:-translate-y-1 transition-all duration-300 flex flex-col justify-between relative overflow-hidden group"
              >
                {/* Accent top border on hover */}
                <div className="absolute top-0 left-0 w-full h-[4px] bg-[#5D804E] transform -translate-y-full group-hover:translate-y-0 transition-transform duration-300" />
                
                <div>
                  {/* Top: Center Name & Head */}
                  <div className="flex justify-between items-start mb-4">
                    <div>
                      <h2 className="text-[18px] font-bold text-[#1A1A1A] group-hover:text-[#5D804E] transition-colors duration-200 leading-tight">
                        {center.companyName}
                      </h2>
                      <span className="text-[11px] font-semibold text-gray-400 tracking-wider uppercase bg-gray-100 dark:bg-slate-700 px-2 py-0.5 rounded-md mt-1 inline-block">
                        Centre ID: CTR00{idx + 1}
                      </span>
                    </div>
                    {center.contactPerson && (
                      <span className="flex items-center gap-1.5 bg-gray-50 border border-gray-200 px-2.5 py-1 rounded-full text-[12px] text-gray-700 font-semibold shadow-sm">
                        <img
                          src={`https://api.dicebear.com/7.x/avataaars/svg?seed=${center.contactPerson}`}
                          alt="avatar"
                          className="h-4 w-4 rounded-full bg-white"
                        />
                        {center.contactPerson}
                      </span>
                    )}
                  </div>

                  <div className="border-t border-dashed border-gray-200 my-4" />

                  {/* Info Rows */}
                  <div className="flex flex-col gap-3.5">
                    {/* Contact info */}
                    <div className="flex items-center gap-3 text-gray-600 text-sm">
                      <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#EAF5F5] dark:bg-slate-700 text-[#5D804E] shrink-0 shadow-xs">
                        <IoCall className="text-xs text-green-500 text-[#5D804E] dark:text-white" style={{ fill: "currentColor" }} />
                      </span>
                      <span className="font-medium text-gray-700">{center.phoneNumber || "N/A"}</span>
                    </div>

                    <div className="flex items-center gap-3 text-gray-600 text-sm break-all">
                      <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#EAF5F5] dark:bg-slate-700 text-[#5D804E] shrink-0 shadow-xs">
                        <IoMail className="text-xs text-green-500 text-[#5D804E] dark:text-white" style={{ fill: "currentColor" }} />
                      </span>
                      <span className="font-medium text-gray-700">{center.email || "N/A"}</span>
                    </div>

                    {/* License details */}
                    {center.gstNumber && (
                      <div className="flex items-center gap-3 text-gray-600 text-sm">
                        <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#EAF5F5] dark:bg-slate-700 text-[#5D804E] shrink-0 shadow-xs">
                          <IoRibbon className="text-xs text-green-500 text-[#5D804E] dark:text-white" style={{ fill: "currentColor" }} />
                        </span>
                        <span className="font-medium text-gray-700">GST: {center.gstNumber}</span>
                      </div>
                    )}

                    {/* Address */}
                    <div className="flex items-start gap-3 text-gray-600 text-sm mt-1">
                      <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#EAF5F5] dark:bg-slate-700 text-[#5D804E] shrink-0 mt-0.5 shadow-xs">
                        <IoLocation className="text-xs text-green-500 text-[#5D804E] dark:text-white" style={{ fill: "currentColor" }} />
                      </span>
                      <div className="leading-normal">
                        <p className="font-medium text-gray-700">{center.building || "Address details not set"}</p>
                        {center.landmark && <p className="text-xs text-gray-400">Near {center.landmark}</p>}
                        {(center.city || center.state) && (
                          <p className="font-semibold text-gray-700 mt-0.5">
                            {center.city}{center.state ? `, ${center.state}` : ""}{center.pinCode ? ` - ${center.pinCode}` : ""}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-6 flex justify-end">
                  <span className="text-[12px] font-bold text-green-700 bg-green-50 px-3 py-1 rounded-full border border-green-200 shadow-xs">
                    Active
                  </span>
                </div>
              </div>
            ))}
          </div>
        </>
      ) : (
        <>
          {/* Header */}
          <div className="flex items-center gap-2">
            <p
              onClick={() => setIsAdding(false)}
              className="mt-[7px] cursor-pointer text-4xl text-[#5D804E] hover:text-[#4E6B41] transition-colors duration-200"
            >
              <IoChevronBackCircle />
            </p>

            <h1 className="text-[30px] font-[500] text-[#1A1A1A]">
              Add new centre
            </h1>
          </div>

          {/* Progress Steps */}
          <div className="mt-5 flex items-center justify-center rounded-[10px] bg-white px-5 py-4 shadow-sm border border-gray-100">
            {steps.map((step, index) => {
              const isCompleted = currentStep > step.number;
              const isActive = currentStep === step.number;
              return (
                <React.Fragment key={step.number}>
                  {/* Step */}
                  <div className="flex items-center">
                    <div className={`flex h-[40px] w-[40px] items-center justify-center rounded-full font-bold text-[16px] transition-all duration-300 ${
                      isActive || isCompleted ? "bg-[#5D804E] text-white" : "bg-[#D8EEEE] text-[#477A7A]"
                    }`}>
                      {isCompleted ? <IoCheckmark className="text-xl" /> : step.number}
                    </div>

                    <div className="ml-[15px] flex flex-col">
                      <h2 className="text-[14px] font-[600] text-[#1A1A1A] leading-tight">
                        Step {step.number}
                      </h2>
                      <p className="text-[12px] text-gray-500 font-medium">{step.title}</p>
                    </div>
                  </div>

                  {/* Line */}
                  {index < steps.length - 1 && (
                    <div className={`mx-[20px] h-[1.5px] w-[80px] transition-colors duration-300 ${
                      currentStep > step.number ? "bg-[#5D804E]" : "bg-[#B8DCD8]"
                    }`} />
                  )}
                </React.Fragment>
              );
            })}
          </div>

          {/* complete form section */}
          {/* details section start */}
          <div className="flex gap-10">
            {/* filling form details section */}
            {currentStep === 1 && (
              <div className="mt-[40px] w-[750px] rounded-[20px] bg-white px-[24px] py-[24px] shadow-sm border border-gray-100">
                <div className="mb-6">
                  <h1 className="text-[24px] font-[600] text-[#1A1A1A]">
                    Centre Information
                  </h1>
                  
                  <div className="mt-4 flex flex-col gap-2">
                    <p className="text-[13px] font-medium text-gray-600">
                      Centre logo
                    </p>

                    <label
                      htmlFor="companyLogo"
                      className="flex h-[80px] w-[80px] cursor-pointer items-center justify-center rounded-full bg-[#FAF9F5] border border-[#DCDAD2] relative shadow-sm hover:border-[#5D804E] transition-all"
                    >
                      <IoBusiness className="text-3xl text-gray-400" />
                      <span className="absolute top-0 right-0 flex h-[22px] w-[22px] items-center justify-center rounded-full bg-white border border-[#DCDAD2] text-green-600 text-[16px] font-bold shadow-sm">
                        +
                      </span>
                    </label>

                    <input
                      id="companyLogo"
                      type="file"
                      accept="image/*"
                      className="hidden"
                    />
                  </div>

                  {/* Centre Name */}
                  <div className="mt-5">
                    <p className="text-[13px] font-semibold text-[#1A1A1A]">
                      Centre Name <span className="text-red-500">*</span>
                    </p>
                    <div className="relative mt-1.5">
                      <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400 text-lg">
                        <IoBusiness />
                      </span>
                      <input
                        type="text"
                        name="companyName"
                        value={formData.companyName}
                        onChange={handleChange}
                        placeholder="Centre Name"
                        className="w-full rounded-lg border border-[#DCDAD2] bg-[#FAF9F5] py-2.5 pl-10 pr-3 text-[14px] text-gray-800 shadow-sm focus:border-[#5D804E] focus:outline-none transition-colors"
                      />
                    </div>
                  </div>

                  {/* Select Centre Head */}
                  <div className="mt-5">
                    <p className="text-[13px] font-semibold text-[#1A1A1A]">
                      Select Centre Head <span className="text-red-500">*</span>
                    </p>
                    <div className="relative mt-1.5">
                      <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400 text-lg">
                        <IoPerson />
                      </span>
                      <select
                        name="contactPerson"
                        value={formData.contactPerson}
                        onChange={handleChange}
                        className="w-full rounded-lg border border-[#DCDAD2] bg-[#FAF9F5] py-2.5 pl-10 pr-10 text-[14px] text-gray-800 shadow-sm focus:border-[#5D804E] focus:outline-none appearance-none cursor-pointer transition-colors"
                      >
                        <option value="">Please select</option>
                        <option value="Veer Sinha">Veer Sinha</option>
                        <option value="Rahul Sharma">Rahul Sharma</option>
                        <option value="Aditya Verma">Aditya Verma</option>
                      </select>
                      <span className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none text-gray-400 text-lg">
                        <IoChevronDown />
                      </span>
                    </div>
                    {formData.contactPerson && (
                      <div className="mt-2.5 flex">
                        <span className="flex items-center gap-1.5 rounded-full bg-[#FAF9F5] border border-[#DCDAD2] px-3.5 py-1 text-sm text-gray-700 shadow-sm">
                          <img
                            src={`https://api.dicebear.com/7.x/avataaars/svg?seed=${formData.contactPerson}`}
                            alt="avatar"
                            className="h-5 w-5 rounded-full bg-white"
                          />
                          <span>{formData.contactPerson}</span>
                          <IoClose
                            className="cursor-pointer text-gray-400 hover:text-gray-700 text-base"
                            onClick={() => setFormData(prev => ({ ...prev, contactPerson: "" }))}
                          />
                        </span>
                      </div>
                    )}
                  </div>

                  {/* Contact number & Email */}
                  <div className="mt-5 grid grid-cols-2 gap-4">
                    <div>
                      <p className="text-[13px] font-semibold text-[#1A1A1A]">
                        Contact number <span className="text-red-500">*</span>
                      </p>
                      <div className="relative mt-1.5">
                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400 text-lg">
                          <IoCall />
                        </span>
                        <input
                          type="text"
                          name="phoneNumber"
                          value={formData.phoneNumber}
                          onChange={handleChange}
                          placeholder="Contact number"
                          className="w-full rounded-lg border border-[#DCDAD2] bg-[#FAF9F5] py-2.5 pl-10 pr-3 text-[14px] text-gray-800 shadow-sm focus:border-[#5D804E] focus:outline-none transition-colors"
                        />
                      </div>
                    </div>

                    <div>
                      <p className="text-[13px] font-semibold text-[#1A1A1A]">
                        Email
                      </p>
                      <div className="relative mt-1.5">
                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400 text-lg">
                          <IoMail />
                        </span>
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="Email"
                          className="w-full rounded-lg border border-[#DCDAD2] bg-[#FAF9F5] py-2.5 pl-10 pr-3 text-[14px] text-gray-800 shadow-sm focus:border-[#5D804E] focus:outline-none transition-colors"
                        />
                      </div>
                    </div>
                  </div>

                </div>
                
                <div className="mt-6 flex justify-end">
                  <button
                    onClick={() => setCurrentStep(2)}
                    className="rounded-xl bg-[#5D804E] hover:bg-[#4E6B41] px-8 py-2.5 text-white font-medium shadow-sm transition-all"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}

            {currentStep === 2 && (
              <div className="mt-[40px] w-[750px] rounded-[20px] bg-white px-[24px] py-[24px] shadow-sm border border-gray-100">
                <h1 className="text-[24px] font-[600] text-[#1A1A1A]">
                  License & Documents Details
                </h1>

                {/* Drug licence details */}
                <div className="mt-5">
                  <h2 className="text-[16px] font-semibold text-[#1A1A1A]">Drug licence details</h2>

                  <div className="mt-3 grid grid-cols-2 gap-4">
                    <div>
                      <p className="text-[13px] font-medium text-gray-600">
                        Part 1 <span className="text-red-500">*</span>
                      </p>
                      <div className="relative mt-1.5">
                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400 text-lg">
                          <IoRibbon />
                        </span>
                        <input
                          type="text"
                          name="drugLicensePart1"
                          value={formData.drugLicensePart1}
                          onChange={handleChange}
                          placeholder="Part 1"
                          className="w-full rounded-lg border border-[#DCDAD2] bg-[#FAF9F5] py-2.5 pl-10 pr-3 text-[14px] text-gray-800 shadow-sm focus:border-[#5D804E] focus:outline-none transition-colors"
                        />
                      </div>
                    </div>

                    <div>
                      <p className="text-[13px] font-medium text-gray-600">
                        Part 2 <span className="text-red-500">*</span>
                      </p>
                      <div className="relative mt-1.5">
                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400 text-lg">
                          <IoRibbon />
                        </span>
                        <input
                          type="text"
                          name="drugLicensePart2"
                          value={formData.drugLicensePart2}
                          onChange={handleChange}
                          placeholder="Part 2"
                          className="w-full rounded-lg border border-[#DCDAD2] bg-[#FAF9F5] py-2.5 pl-10 pr-3 text-[14px] text-gray-800 shadow-sm focus:border-[#5D804E] focus:outline-none transition-colors"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Documents details */}
                <div className="mt-5">
                  <h2 className="text-[16px] font-semibold text-[#1A1A1A]">Documents details</h2>

                  <div className="mt-3 grid grid-cols-2 gap-4">
                    <div>
                      <p className="text-[13px] font-medium text-gray-600">
                        Pan number <span className="text-red-500">*</span>
                      </p>
                      <div className="relative mt-1.5">
                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400 text-lg">
                          <IoCard />
                        </span>
                        <input
                          type="text"
                          name="panNumber"
                          value={formData.panNumber}
                          onChange={handleChange}
                          placeholder="PAN Number"
                          className="w-full rounded-lg border border-[#DCDAD2] bg-[#FAF9F5] py-2.5 pl-10 pr-3 text-[14px] text-gray-800 shadow-sm focus:border-[#5D804E] focus:outline-none transition-colors"
                        />
                      </div>
                    </div>

                    <div>
                      <p className="text-[13px] font-medium text-gray-600">
                        FSSAI number <span className="text-red-500">*</span>
                      </p>
                      <div className="relative mt-1.5">
                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400 text-lg">
                          <IoRibbon />
                        </span>
                        <input
                          type="text"
                          name="fssaiNumber"
                          value={formData.fssaiNumber}
                          onChange={handleChange}
                          placeholder="FSSAI Number"
                          className="w-full rounded-lg border border-[#DCDAD2] bg-[#FAF9F5] py-2.5 pl-10 pr-3 text-[14px] text-gray-800 shadow-sm focus:border-[#5D804E] focus:outline-none transition-colors"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* GST Authentication */}
                <div className="mt-5">
                  <h2 className="text-[16px] font-semibold text-[#1A1A1A]">GST Authentication</h2>
                  <p className="mt-2 text-[13px] text-gray-500 font-medium">Authentication by</p>
                  <div className="mt-2 flex gap-4">
                    <label className="flex w-[50%] items-center gap-2 rounded-lg border border-[#DCDAD2] bg-white p-2.5 text-[14px] cursor-pointer shadow-sm hover:bg-gray-50 transition-colors">
                      <input type="radio" name="gstAuth" defaultChecked />
                      <span className="text-gray-700 font-medium">Automatic</span>
                    </label>
                    <label className="flex w-[50%] items-center gap-2 rounded-lg border border-[#DCDAD2] bg-white p-2.5 text-[14px] cursor-pointer shadow-sm hover:bg-gray-50 transition-colors">
                      <input type="radio" name="gstAuth" />
                      <span className="text-gray-700 font-medium">Manual</span>
                    </label>
                  </div>
                </div>

                {/* GST Number */}
                <div className="mt-5">
                  <p className="text-[13px] font-medium text-gray-600">
                    GST number <span className="text-red-500">*</span>
                  </p>
                  <div className="relative mt-1.5">
                    <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400 text-lg">
                      <IoBusiness />
                    </span>
                    <input
                      type="text"
                      name="gstNumber"
                      value={formData.gstNumber}
                      onChange={handleChange}
                      placeholder="GST Number"
                      className="w-full rounded-lg border border-[#DCDAD2] bg-[#FAF9F5] py-2.5 pl-10 pr-3 text-[14px] text-gray-800 shadow-sm focus:border-[#5D804E] focus:outline-none transition-colors"
                    />
                  </div>
                </div>

                {/* GST Certificate */}
                <div className="mt-5">
                  <p className="text-[13px] font-medium text-gray-600">
                    GST Certificate <span className="text-red-500">*</span>
                  </p>
                  <div className="mt-2 flex flex-col items-center justify-center rounded-lg border-2 border-dashed border-[#B8DCD8] bg-[#FAF9F5] p-6 text-center cursor-pointer hover:bg-white transition-all shadow-sm">
                    <IoCloudUpload className="text-3xl text-[#5D804E] mb-2" />
                    <span className="text-[14px] font-semibold text-[#1A1A1A]">Upload logo image</span>
                    <span className="text-[12px] text-gray-400 mt-1">Only PNG, JPG or JPEG files are accepted</span>
                  </div>
                </div>

                {/* Buttons */}
                <div className="mt-6 flex justify-end gap-3">
                  <button
                    onClick={() => setCurrentStep(1)}
                    className="rounded-xl border border-gray-300 px-6 py-2.5 text-gray-500 font-medium shadow-sm hover:bg-gray-50 transition-colors"
                  >
                    Previous
                  </button>

                  <button
                    onClick={() => setCurrentStep(3)}
                    className="rounded-xl bg-[#5D804E] hover:bg-[#4E6B41] px-8 py-2.5 text-white font-medium shadow-sm transition-all"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}

            {currentStep === 3 && (
              <div className="mt-[40px] w-[750px] rounded-[20px] bg-white px-[24px] py-[24px] shadow-sm border border-gray-100">
                <h1 className="text-[24px] font-[600] text-[#1A1A1A] mb-4">
                  Address
                </h1>

                {/* Map Mockup */}
                <div className="relative overflow-hidden rounded-lg border border-[#DCDAD2] mb-5 shadow-sm">
                  <img src={noidaMapImage} alt="Noida Map" className="w-full h-[180px] object-cover" />
                  <button className="absolute top-2 right-2 rounded-md bg-white border border-[#DCDAD2] p-1.5 shadow-sm text-gray-600 hover:text-black hover:bg-gray-50 transition-all">
                    <IoExpand className="text-sm" />
                  </button>
                </div>

                {/* Coordinates Grid */}
                <div className="grid grid-cols-2 gap-4 mb-4">
                  <div>
                    <p className="text-[13px] font-semibold text-[#1A1A1A]">Latitude</p>
                    <div className="relative mt-1.5">
                      <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400 text-lg">
                        <IoLocation />
                      </span>
                      <input
                        type="text"
                        name="latitude"
                        value={formData.latitude}
                        onChange={handleChange}
                        placeholder="Latitude"
                        className="w-full rounded-lg border border-[#DCDAD2] bg-[#FAF9F5] py-2.5 pl-10 pr-3 text-[14px] text-gray-800 shadow-sm focus:border-[#5D804E] focus:outline-none transition-colors"
                      />
                    </div>
                  </div>

                  <div>
                    <p className="text-[13px] font-semibold text-[#1A1A1A]">Longitude</p>
                    <div className="relative mt-1.5">
                      <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400 text-lg">
                        <IoLocation />
                      </span>
                      <input
                        type="text"
                        name="longitude"
                        value={formData.longitude}
                        onChange={handleChange}
                        placeholder="Longitude"
                        className="w-full rounded-lg border border-[#DCDAD2] bg-[#FAF9F5] py-2.5 pl-10 pr-3 text-[14px] text-gray-800 shadow-sm focus:border-[#5D804E] focus:outline-none transition-colors"
                      />
                    </div>
                  </div>
                </div>

                {/* Address Form Inputs */}
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <p className="text-[13px] font-semibold text-[#1A1A1A]">Building Number, Block, Area</p>
                    <div className="relative mt-1.5">
                      <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400 text-lg">
                        <IoHome />
                      </span>
                      <input
                        type="text"
                        name="building"
                        value={formData.building}
                        onChange={handleChange}
                        placeholder="Building Number, Block, Area"
                        className="w-full rounded-lg border border-[#DCDAD2] bg-[#FAF9F5] py-2.5 pl-10 pr-3 text-[14px] text-gray-800 shadow-sm focus:border-[#5D804E] focus:outline-none transition-colors"
                      />
                    </div>
                  </div>

                  <div>
                    <p className="text-[13px] font-semibold text-[#1A1A1A]">Landmark</p>
                    <div className="relative mt-1.5">
                      <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400 text-lg">
                        <IoCompass />
                      </span>
                      <input
                        type="text"
                        name="landmark"
                        value={formData.landmark}
                        onChange={handleChange}
                        placeholder="Landmark"
                        className="w-full rounded-lg border border-[#DCDAD2] bg-[#FAF9F5] py-2.5 pl-10 pr-3 text-[14px] text-gray-800 shadow-sm focus:border-[#5D804E] focus:outline-none transition-colors"
                      />
                    </div>
                  </div>

                  <div>
                    <p className="text-[13px] font-semibold text-[#1A1A1A]">Area pin code <span className="text-red-500">*</span></p>
                    <div className="relative mt-1.5">
                      <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400 text-lg">
                        <IoLocation />
                      </span>
                      <input
                        type="text"
                        name="pinCode"
                        value={formData.pinCode}
                        onChange={handleChange}
                        placeholder="Pin Code"
                        className="w-full rounded-lg border border-[#DCDAD2] bg-[#FAF9F5] py-2.5 pl-10 pr-3 text-[14px] text-gray-800 shadow-sm focus:border-[#5D804E] focus:outline-none transition-colors"
                      />
                    </div>
                  </div>

                  <div>
                    <p className="text-[13px] font-semibold text-[#1A1A1A]">City/Town <span className="text-red-500">*</span></p>
                    <div className="relative mt-1.5">
                      <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400 text-lg">
                        <IoMap />
                      </span>
                      <input
                        type="text"
                        name="city"
                        value={formData.city}
                        onChange={handleChange}
                        placeholder="City"
                        className="w-full rounded-lg border border-[#DCDAD2] bg-[#FAF9F5] py-2.5 pl-10 pr-3 text-[14px] text-gray-800 shadow-sm focus:border-[#5D804E] focus:outline-none transition-colors"
                      />
                    </div>
                  </div>

                  <div>
                    <p className="text-[13px] font-semibold text-[#1A1A1A]">District <span className="text-red-500">*</span></p>
                    <div className="relative mt-1.5">
                      <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400 text-lg">
                        <IoMap />
                      </span>
                      <input
                        type="text"
                        name="district"
                        value={formData.district}
                        onChange={handleChange}
                        placeholder="District"
                        className="w-full rounded-lg border border-[#DCDAD2] bg-[#FAF9F5] py-2.5 pl-10 pr-3 text-[14px] text-gray-800 shadow-sm focus:border-[#5D804E] focus:outline-none transition-colors"
                      />
                    </div>
                  </div>

                  <div>
                    <p className="text-[13px] font-semibold text-[#1A1A1A]">State <span className="text-red-500">*</span></p>
                    <div className="relative mt-1.5">
                      <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400 text-lg">
                        <IoMap />
                      </span>
                      <input
                        type="text"
                        name="state"
                        value={formData.state}
                        onChange={handleChange}
                        placeholder="State"
                        className="w-full rounded-lg border border-[#DCDAD2] bg-[#FAF9F5] py-2.5 pl-10 pr-3 text-[14px] text-gray-800 shadow-sm focus:border-[#5D804E] focus:outline-none transition-colors"
                      />
                    </div>
                  </div>
                </div>

                <div className="mt-6 flex justify-end gap-3">
                  <button
                    onClick={() => setCurrentStep(2)}
                    className="rounded-xl border border-gray-300 px-6 py-2.5 text-gray-500 font-medium shadow-sm hover:bg-gray-50 transition-colors"
                  >
                    Previous
                  </button>

                  <button
                    onClick={handleSave}
                    className="rounded-xl bg-[#5D804E] hover:bg-[#4E6B41] px-8 py-2.5 text-white font-medium shadow-sm transition-all"
                  >
                    Save
                  </button>
                </div>
              </div>
            )}

            {/* from detaisl section  */}
            <div className="mt-[40px] w-[750px] rounded-[20px] bg-white px-[24px] py-[24px] shadow-sm border border-gray-100">
              <h1 className="text-[24px] font-[600] text-[#1A1A1A] text-center mb-6">
                CENTRES REGISTRATION RECORD
              </h1>
              
              {/* Section 1: Centre Information */}
              <div className="border border-gray-300 rounded-lg overflow-hidden shadow-sm">
                <div className="flex justify-between items-center bg-[#D8EEEE] px-4 py-2.5 text-[14px] font-bold text-[#477A7A]">
                  <span>1. CENTRE INFORMATION</span>
                  {currentStep > 1 && <IoCheckmark className="text-green-500 text-xl font-bold" />}
                </div>

                {vendorItems.map((item) => (
                  <div
                    key={item}
                    className="grid grid-cols-2 border-t border-gray-200 bg-white"
                  >
                    <div className="px-4 py-2 text-[14px] font-medium text-gray-500">
                      {item}
                    </div>
                    <div className="border-l border-gray-200 px-4 py-2 text-[14px] text-gray-800 font-semibold bg-[#FAF9F5]">
                      {currentStep >= 1 ? (formData[vendorLabelMap[item]] || "") : ""}
                    </div>
                  </div>
                ))}
              </div>

              {/* Section 2: Licensing & Documents Details */}
              <div className="mt-5 border border-gray-300 rounded-lg overflow-hidden shadow-sm">
                <div className="flex justify-between items-center bg-[#D8EEEE] px-4 py-2.5 text-[14px] font-bold text-[#477A7A]">
                  <span>2. LICENSING & DOCUMENTS DETAILS</span>
                  {currentStep > 2 && <IoCheckmark className="text-green-500 text-xl font-bold" />}
                </div>

                {licenseItems.map((item) => (
                  <div
                    key={item}
                    className="grid grid-cols-2 border-t border-gray-200 bg-white"
                  >
                    <div className="px-4 py-2 text-[14px] font-medium text-gray-500">
                      {item}
                    </div>
                    <div className="border-l border-gray-200 px-4 py-2 text-[14px] text-gray-800 font-semibold bg-[#FAF9F5]">
                      {currentStep >= 2 ? (formData[licenseLabelMap[item]] || "") : ""}
                    </div>
                  </div>
                ))}
              </div>

              {/* Section 3: Billing Address */}
              <div className="mt-5 border border-gray-300 rounded-lg overflow-hidden shadow-sm">
                <div className="flex justify-between items-center bg-[#D8EEEE] px-4 py-2.5 text-[14px] font-bold text-[#477A7A]">
                  <span>4. BILLING ADDRESS</span>
                </div>

                {addressItems.map((item) => (
                  <div
                    key={item}
                    className="grid grid-cols-2 border-t border-gray-200 bg-white"
                  >
                    <div className="px-4 py-2 text-[14px] font-medium text-gray-500">
                      {item}
                    </div>
                    <div className="border-l border-gray-200 px-4 py-2 text-[14px] text-gray-800 font-semibold bg-[#FAF9F5]">
                      {currentStep >= 3 ? (formData[addressLabelMap[item]] || "") : ""}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Centers;
